
export const getUserInfo = state => {
    return state.userinfo
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js